import axios from 'axios';
import { getToken, isSessionValid, clearSession } from './services/auth';

const api = axios.create({ baseURL: '' });

api.interceptors.request.use((config)=>{
  if(!isSessionValid()){
    clearSession();
  } else {
    const token = getToken();
    if(token){ config.headers['Authorization'] = `Bearer ${token}`; }
  }
  return config;
});

export default api; 